"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TablePaginationActions.default;
  }
});
Object.defineProperty(exports, "tablePaginationActionsClasses", {
  enumerable: true,
  get: function () {
    return _tablePaginationActionsClasses.default;
  }
});
var _TablePaginationActions = _interopRequireDefault(require("./TablePaginationActions"));
var _tablePaginationActionsClasses = _interopRequireDefault(require("./tablePaginationActionsClasses"));